import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EmpoweringSocietyThroughService from "./sections/EmpoweringSocietyThroughService";
import TrustAccountability from "./sections/TrustAccountability";
import TheEducationGapInGhana from "./sections/TheEducationGapInGhana";
import OurPillarsOfEmpowerment from "./sections/OurPillarsOfEmpowerment";
import OurImpactTracker from "./sections/OurImpactTracker";
import RealStoriesOfImpact from "./sections/RealStoriesOfImpact";
import TakeTheNextStep from "./sections/TakeTheNextStep";
import FooterInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="bg-background text-foreground">
      <Header />
      <main>
        <EmpoweringSocietyThroughService />
        <TrustAccountability />
        <TheEducationGapInGhana />
        <OurPillarsOfEmpowerment />
        <OurImpactTracker />
        <RealStoriesOfImpact />
        <TakeTheNextStep />
      </main>
      <FooterInfo />
    </div>;
}